const HiddenFrame = () => {
  return (
    <iframe
      id='hiddenFrame'
      name='hiddenFrame'
      title='hiddenFrame'
      style={{
        display: 'none',
        position: 'absolute',
        top: 135,
        left: 15,
        width: 450,
        height: 700,
      }}
    />
  );
};

export default HiddenFrame;
